import React from 'react';
import { Row, Col } from 'reactstrap';
import ContentContainer from './ContentContainer';
import ProgressBar from '../../../components/ProgressBar';

export class ContactContainer extends React.Component {
  render() {
    return (
      <div>
        <Row>
          <Col xs="12">
            <ProgressBar percentage={35} />
          </Col>
          <Col xs='12'>
            <ContentContainer {...this.props} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default ContactContainer;
